function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndulgeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-7a5978b7-cdcb-45b4-b1fe-fe7205839d46",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1367.05 2644.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-5e32086e-1c00-45a0-ac27-6468c1cb93a3",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.49,2455.51l8.94.44-.61,24.76H0l.61-26.51,9.75.44v-99.9l-6.7.44-.61-27.82h40.02l.41,25.85-8.33.44-3.66,101.87Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61,2368.97c5.14,0,9.38,1.42,12.7,4.27,3.32,2.85,5.92,6.61,7.82,11.28,1.89,4.68,3.15,10.08,3.76,16.21.61,6.13.81,12.49.61,19.06s-.71,13.11-1.52,19.61c-.81,6.5-1.66,12.53-2.54,18.07-.88,5.55-1.76,10.37-2.64,14.46-.88,4.09-1.46,7.01-1.73,8.76h-39c6.5-19.13,11.85-36.29,16.05-51.48,1.76-6.43,3.32-12.71,4.67-18.84,1.35-6.13,2.3-11.61,2.84-16.43.54-4.82.57-8.73.1-11.72-.48-2.99-1.73-4.49-3.76-4.49-4.34,0-8.43,2.56-12.29,7.67-3.86,5.11-7.42,11.58-10.67,19.39-3.25,7.82-6.13,16.4-8.63,25.74-2.51,9.35-4.5,18.26-5.99,26.73l-1.22,23.44h-20.11v-109.54h25.8l-2.84,55.43c1.76-6.57,3.86-13.25,6.3-20.05,2.44-6.79,5.25-12.96,8.43-18.51,3.18-5.55,6.74-10.11,10.67-13.69,3.93-3.58,8.33-5.37,13.2-5.37Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.68,2325.15l-5.89,155.55h-20.11v-63.1c-1.76,6.87-3.89,14.1-6.4,21.69-2.51,7.6-5.42,14.64-8.73,21.14-3.32,6.5-7.04,11.87-11.17,16.1-4.13,4.24-8.7,6.35-13.71,6.35s-9.14-1.31-11.98-3.94-4.81-6.21-5.89-10.74c-1.09-4.53-1.42-9.71-1.02-15.55.41-5.84,1.29-11.94,2.64-18.29,1.35-6.35,3.05-12.74,5.08-19.17,2.03-6.43,4.13-12.49,6.3-18.18,2.16-5.7,4.2-10.81,6.09-15.34,1.89-4.53,3.45-8.03,4.67-10.52h34.13v-43.82l26-2.19ZM175.3,2474.79c3.38.29,6.91-1.9,10.56-6.57,3.66-4.67,7.18-10.81,10.56-18.4,3.38-7.59,6.5-16.14,9.34-25.63,2.84-9.49,5.15-18.91,6.91-28.26v-17.09c-2.57,3.21-5.69,7.45-9.34,12.71s-7.45,11.39-11.38,18.4c-3.93,6.43-7.41,13.36-10.46,20.81s-5.42,14.39-7.11,20.81c-1.7,6.43-2.54,11.87-2.54,16.32s1.15,6.76,3.45,6.9Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.27,2371.16l-5.69,109.54h-20.11v-62.22c-1.62,6.72-3.66,13.84-6.09,21.36-2.44,7.52-5.32,14.46-8.63,20.81-3.32,6.35-7.08,11.65-11.27,15.88-4.2,4.24-8.94,6.35-14.22,6.35s-9.38-1.42-12.7-4.27c-3.32-2.85-5.93-6.61-7.82-11.28-1.9-4.67-3.15-10.08-3.76-16.21-.61-6.13-.81-12.49-.61-19.06s.71-13.11,1.52-19.61c.81-6.5,1.66-12.52,2.54-18.07.88-5.55,1.76-10.37,2.64-14.46.88-4.09,1.45-7.01,1.73-8.76h39c-6.64,19.28-11.98,36.44-16.05,51.48-1.76,6.43-3.35,12.75-4.77,18.95-1.42,6.21-2.41,11.72-2.95,16.54-.54,4.82-.54,8.69,0,11.61.54,2.92,1.83,4.38,3.86,4.38,4.33,0,8.43-2.59,12.29-7.78,3.86-5.18,7.41-11.72,10.66-19.61s6.13-16.54,8.63-25.96c2.5-9.42,4.5-18.44,5.99-27.06v-22.57h25.8Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.89,2327.34l26.21-2.19c-1.49,9.64-2.95,19.28-4.37,28.92-1.42,9.64-2.57,18.88-3.45,27.71-.88,8.84-1.29,16.98-1.22,24.43.07,7.45.84,13.8,2.34,19.06,1.49,5.26,3.93,9.17,7.31,11.72,3.38,2.56,7.92,3.25,13.61,2.08l-.81,41.63h-39.61v-153.36Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.65,2371.16v31.88c0,11.17-.04,21.84-.1,31.99-.07,10.15-.27,19.21-.61,27.17-.34,7.96-.85,13.77-1.52,17.42-2.3,11.97-6.13,21.54-11.48,28.7-5.35,7.15-11.65,12.6-18.89,16.32-7.25,3.72-15.13,6.17-23.67,7.34-8.53,1.17-17.2,1.75-26,1.75l.81-43.6c4.6,4.82,9.75,8.11,15.44,9.86s11.27,2.23,16.76,1.42c5.49-.8,10.56-2.78,15.24-5.92,4.67-3.14,8.29-7.27,10.87-12.38,1.35-2.92,2.54-6.64,3.55-11.17,1.02-4.53,1.93-9.49,2.74-14.9-1.62,3.36-3.52,6.61-5.69,9.75-2.17,3.14-4.61,5.92-7.31,8.33-2.71,2.41-5.82,4.31-9.34,5.7-3.52,1.39-7.38,2.08-11.58,2.08-5.96,0-11.21-1.53-15.74-4.6-4.54-3.07-8.33-7.12-11.38-12.16s-5.35-10.81-6.91-17.31c-1.56-6.5-2.3-13.18-2.23-20.05.07-6.86.95-13.69,2.64-20.48,1.69-6.79,4.23-12.96,7.62-18.51,3.66-6.13,8.29-10.77,13.91-13.91,5.62-3.14,11.58-5.15,17.88-6.02,6.3-.88,12.49-.77,18.59.33,6.09,1.1,11.51,2.89,16.25,5.37,0-.73.03-1.46.1-2.19.07-.73.1-1.46.1-2.19h9.95ZM454.4,2469.97c4.74-.44,8.84-2.66,12.29-6.68,3.45-4.02,6.4-9.16,8.84-15.45,2.44-6.28,4.4-13.18,5.89-20.7,1.49-7.52,2.64-15.01,3.45-22.46-1.9-1.17-4.4-2.22-7.52-3.18-3.12-.95-6.5-1.35-10.16-1.21-3.66.15-7.41,1.02-11.27,2.63-3.86,1.61-7.35,4.38-10.46,8.33-2.84,3.5-5.01,7.41-6.5,11.72-1.49,4.31-2.44,8.69-2.84,13.14-.41,4.46-.3,8.76.3,12.93.61,4.16,1.73,7.85,3.35,11.06,1.62,3.21,3.66,5.73,6.09,7.56,2.44,1.83,5.28,2.59,8.53,2.3Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.22,2445.43c5.14,1.02,9.95,1.24,14.42.66,4.47-.58,8.39-1.46,11.78-2.63,3.93-1.31,7.52-2.92,10.77-4.82,0,1.17-.03,3.94-.1,8.33-.07,4.38-.1,8.98-.1,13.8-.14,5.7-.2,11.91-.2,18.62-2.44.44-5.48,1.02-9.14,1.75-3.66.73-7.72,1.24-12.19,1.53-4.47.29-9.18.22-14.12-.22-4.95-.44-9.89-1.5-14.83-3.18-4.94-1.68-9.72-4.09-14.32-7.23-4.6-3.14-8.73-7.41-12.39-12.82-4.06-5.7-6.94-11.9-8.63-18.62-1.7-6.72-2.23-13.4-1.62-20.05.61-6.64,2.37-13.07,5.28-19.28,2.91-6.21,6.91-11.72,11.98-16.54,5.08-4.82,11.27-8.65,18.59-11.5,7.31-2.85,15.71-4.27,25.19-4.27,7.45,0,13.61,1.09,18.48,3.29,4.88,2.19,8.19,5,9.95,8.43,1.76,3.43,1.9,7.23.41,11.39-1.49,4.16-4.77,8.21-9.85,12.16-5.08,3.94-12.12,7.49-21.12,10.62-9.01,3.14-20.08,5.37-33.21,6.68.95,5.55,3.38,10.52,7.31,14.9,3.93,4.38,9.82,7.38,17.67,8.98ZM555.55,2375.32c-3.39,1.17-6.5,3.18-9.34,6.03-2.84,2.85-5.25,6.13-7.21,9.86-1.96,3.72-3.45,7.78-4.47,12.16s-1.32,8.62-.91,12.71c3.66-.29,7.79-1.21,12.39-2.74,4.6-1.53,8.97-3.51,13.1-5.92,4.13-2.41,7.65-5.15,10.56-8.22,2.91-3.07,4.5-6.35,4.77-9.86.27-2.92-.14-5.44-1.22-7.56-1.09-2.12-2.57-3.76-4.47-4.93-1.9-1.17-4.03-1.9-6.4-2.19-2.37-.29-4.64-.07-6.8.66Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.05,2371.16l25.8-2.19-3.86,111.73h-21.94v-109.54ZM913.87,2341.15c0-4.23,1.15-7.59,3.45-10.08,2.3-2.48,5.35-3.72,9.14-3.72s6.84,1.24,9.14,3.72c2.3,2.49,3.45,5.84,3.45,10.08s-1.15,7.38-3.45,9.86c-2.3,2.49-5.35,3.72-9.14,3.72s-6.84-1.24-9.14-3.72c-2.3-2.48-3.45-5.77-3.45-9.86Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.02,2368.97c5.14,0,9.38,1.42,12.7,4.27,3.32,2.85,5.92,6.61,7.82,11.28,1.89,4.68,3.15,10.08,3.76,16.21.61,6.13.81,12.49.61,19.06s-.71,13.11-1.52,19.61c-.81,6.5-1.66,12.53-2.54,18.07-.88,5.55-1.76,10.37-2.64,14.46-.88,4.09-1.46,7.01-1.73,8.76h-39c6.5-19.13,11.85-36.29,16.05-51.48,1.76-6.43,3.32-12.71,4.67-18.84,1.35-6.13,2.3-11.61,2.84-16.43.54-4.82.57-8.73.1-11.72-.48-2.99-1.73-4.49-3.76-4.49-4.34,0-8.43,2.56-12.29,7.67-3.86,5.11-7.41,11.58-10.66,19.39-3.25,7.82-6.13,16.4-8.63,25.74-2.51,9.35-4.5,18.26-5.99,26.73l-1.22,23.44h-20.11v-109.54h25.8l-2.84,55.43c1.76-6.57,3.86-13.25,6.3-20.05,2.44-6.79,5.25-12.96,8.43-18.51,3.18-5.55,6.74-10.11,10.66-13.69,3.93-3.58,8.33-5.37,13.2-5.37Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.07,2384.09c-3.25,2.49-6.37,5.51-9.34,9.09-2.98,3.58-5.45,7.67-7.41,12.27-1.96,4.6-2.81,9.75-2.54,15.45.27,7.45,2.27,13,5.99,16.65,3.72,3.65,8.06,6.02,13,7.12,4.94,1.09,9.99,1.21,15.13.33,5.15-.88,9.34-2.19,12.59-3.94v39.65c-.81.44-2.07.8-3.76,1.1-1.7.29-3.49.51-5.38.66-1.9.14-3.76.25-5.59.33-1.83.07-3.35.11-4.57.11-5.55,0-11.24-1.02-17.06-3.07-5.82-2.04-11.14-5.22-15.95-9.53-4.81-4.31-8.77-9.71-11.88-16.21-3.12-6.5-4.67-14.27-4.67-23.33,0-11.39,2.81-21.54,8.43-30.45,5.62-8.91,15-16.21,28.13-21.91h-35.34v-7.23c6.63,0,12.32-.11,17.06-.33,4.74-.22,8.63-1.09,11.68-2.63,3.05-1.53,5.28-3.94,6.7-7.23s2.13-7.92,2.13-13.91h14.22v24.1h19.7v7.23h-22.95c-2.3,1.31-5.08,3.21-8.33,5.7Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.29,2368.97c5.14,0,9.38,1.42,12.7,4.27,3.32,2.85,5.92,6.61,7.82,11.28,1.89,4.68,3.15,10.08,3.76,16.21.61,6.13.81,12.49.61,19.06s-.71,13.11-1.52,19.61c-.81,6.5-1.66,12.53-2.54,18.07-.88,5.55-1.76,10.37-2.64,14.46-.88,4.09-1.46,7.01-1.73,8.76h-39c6.5-19.13,11.85-36.29,16.05-51.48,1.76-6.43,3.32-12.71,4.67-18.84,1.35-6.13,2.3-11.61,2.84-16.43.54-4.82.57-8.73.1-11.72-.48-2.99-1.73-4.49-3.76-4.49-4.34,0-8.46,2.63-12.39,7.89-3.93,5.26-7.55,11.91-10.87,19.94-3.32,8.03-6.23,16.83-8.73,26.4-2.51,9.57-4.5,18.66-5.99,27.28l-.81,21.47h-20.11v-153.36l26-2.19-4.06,104.94c1.76-6.57,3.86-13.47,6.3-20.7,2.44-7.23,5.28-13.84,8.53-19.83,3.25-5.99,6.94-10.92,11.07-14.79,4.13-3.87,8.7-5.81,13.71-5.81Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.82,2445.43c5.15,1.02,9.95,1.24,14.42.66,4.47-.58,8.4-1.46,11.78-2.63,3.93-1.31,7.52-2.92,10.77-4.82,0,1.17-.04,3.94-.1,8.33-.07,4.38-.1,8.98-.1,13.8-.14,5.7-.2,11.91-.2,18.62-2.44.44-5.48,1.02-9.14,1.75-3.66.73-7.72,1.24-12.19,1.53-4.47.29-9.18.22-14.12-.22-4.94-.44-9.89-1.5-14.83-3.18-4.95-1.68-9.72-4.09-14.32-7.23-4.61-3.14-8.73-7.41-12.39-12.82-4.06-5.7-6.94-11.9-8.63-18.62-1.69-6.72-2.23-13.4-1.62-20.05.61-6.64,2.37-13.07,5.28-19.28,2.91-6.21,6.91-11.72,11.98-16.54,5.08-4.82,11.27-8.65,18.59-11.5,7.31-2.85,15.71-4.27,25.19-4.27,7.45,0,13.61,1.09,18.49,3.29,4.88,2.19,8.19,5,9.95,8.43,1.76,3.43,1.89,7.23.41,11.39-1.49,4.16-4.77,8.21-9.85,12.16-5.08,3.94-12.12,7.49-21.13,10.62-9.01,3.14-20.08,5.37-33.21,6.68.95,5.55,3.38,10.52,7.31,14.9,3.93,4.38,9.82,7.38,17.67,8.98ZM1322.15,2375.32c-3.39,1.17-6.5,3.18-9.34,6.03-2.84,2.85-5.25,6.13-7.21,9.86-1.96,3.72-3.45,7.78-4.47,12.16s-1.32,8.62-.91,12.71c3.66-.29,7.79-1.21,12.39-2.74,4.6-1.53,8.97-3.51,13.1-5.92,4.13-2.41,7.65-5.15,10.56-8.22,2.91-3.07,4.5-6.35,4.77-9.86.27-2.92-.14-5.44-1.22-7.56-1.08-2.12-2.57-3.76-4.47-4.93-1.9-1.17-4.03-1.9-6.4-2.19-2.37-.29-4.64-.07-6.8.66Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.26,2600.07v38.78c-3.39,1.61-8.2,2.99-14.42,4.16-6.23,1.17-13,1.35-20.31.55-7.31-.8-14.66-2.88-22.04-6.24-7.38-3.36-13.91-8.76-19.6-16.21-5.55-7.45-9.21-15.67-10.97-24.65-1.76-8.98-1.66-17.71.3-26.18,1.96-8.47,5.79-16.1,11.48-22.89,5.69-6.79,13.27-11.65,22.75-14.57,6.91-2.19,13.71-3.1,20.42-2.74,6.7.37,12.7,1.21,17.98,2.52,6.23,1.61,12.12,3.65,17.67,6.13l-2.44,18.4c-3.25-4.67-6.94-8.58-11.07-11.72-4.13-3.14-8.36-5.4-12.7-6.79-4.34-1.39-8.7-1.86-13.1-1.42-4.4.44-8.57,1.75-12.49,3.94-5.42,3.07-9.34,7.52-11.78,13.36-2.44,5.84-3.49,11.94-3.15,18.29.34,6.35,2.1,12.34,5.28,17.96,3.18,5.62,7.75,9.75,13.71,12.38,4.33,2.49,9.11,3.72,14.32,3.72s10.06-.51,14.52-1.53c5.28-1.17,10.49-2.92,15.64-5.26Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.51,2529.97c7.18-.44,12.56,1.13,16.15,4.71,3.59,3.58,6.02,8.33,7.31,14.24,1.29,5.92,1.69,12.53,1.22,19.83-.48,7.3-1.19,14.39-2.13,21.25h-36.56c1.08-2.63,2.23-5.77,3.45-9.42,1.22-3.65,2.34-7.41,3.35-11.28,1.02-3.87,1.93-7.7,2.74-11.5.81-3.8,1.29-7.15,1.42-10.08.13-2.92-.07-5.22-.61-6.9-.54-1.68-1.62-2.37-3.25-2.08-4.47.73-8.67,3.8-12.59,9.2-3.93,5.4-7.52,11.94-10.77,19.61s-6.06,15.88-8.43,24.65c-2.37,8.76-4.16,16.94-5.38,24.54l-1.42,24.98h-20.11v-109.54h25.8l-2.84,55.65c1.76-6.43,3.93-13,6.5-19.72,2.57-6.72,5.59-12.85,9.04-18.4,3.45-5.55,7.42-10.15,11.88-13.8,4.47-3.65,9.55-5.62,15.23-5.92Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.86,2532.16l-5.69,109.54h-20.11v-62.22c-1.62,6.72-3.66,13.84-6.09,21.36-2.44,7.52-5.32,14.46-8.63,20.81-3.32,6.35-7.08,11.65-11.27,15.88-4.2,4.24-8.94,6.35-14.22,6.35s-9.38-1.42-12.7-4.27c-3.32-2.85-5.93-6.61-7.82-11.28-1.9-4.67-3.15-10.08-3.76-16.21-.61-6.13-.81-12.49-.61-19.06s.71-13.11,1.52-19.61c.81-6.5,1.66-12.52,2.54-18.07.88-5.55,1.76-10.37,2.64-14.46.88-4.09,1.45-7.01,1.73-8.76h39c-6.64,19.28-11.99,36.44-16.05,51.48-1.76,6.43-3.35,12.75-4.77,18.95-1.42,6.21-2.41,11.72-2.95,16.54-.54,4.82-.54,8.69,0,11.61.54,2.92,1.83,4.38,3.86,4.38,4.33,0,8.43-2.59,12.29-7.78,3.86-5.18,7.42-11.72,10.67-19.61s6.13-16.54,8.63-25.96c2.5-9.42,4.5-18.44,5.99-27.06v-22.57h25.8Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.41,2559.76c-3.93-1.46-7.55-2.7-10.87-3.72-3.32-1.02-5.86-1.46-7.62-1.31-1.76.15-2.57.99-2.44,2.52.13,1.53,1.69,3.98,4.67,7.34,1.08,1.9,3.15,4.16,6.2,6.79,3.05,2.63,6.53,5.44,10.46,8.43,3.93,3,8.05,6.1,12.39,9.31,4.33,3.21,8.36,6.43,12.09,9.64,3.72,3.21,6.91,6.35,9.55,9.42,2.64,3.07,4.23,5.92,4.77,8.54,1.35,6.43.84,11.54-1.52,15.34-2.37,3.8-5.89,6.61-10.56,8.43s-10.02,2.88-16.05,3.18c-6.03.29-11.92.14-17.67-.44-5.76-.58-11-1.39-15.74-2.41-4.74-1.02-8.06-1.9-9.95-2.63v-40.09c10.56,5.55,19.97,10.08,28.24,13.58,3.52,1.46,6.94,2.78,10.26,3.94,3.32,1.17,6.3,2.01,8.94,2.52,2.64.51,4.7.55,6.2.11,1.49-.44,2.16-1.53,2.03-3.29-.27-2.63-1.76-5.48-4.47-8.54-2.71-3.07-6.06-6.24-10.05-9.53-4-3.29-8.33-6.64-13-10.08-4.67-3.43-9.14-6.86-13.41-10.3-4.27-3.43-7.96-6.79-11.07-10.08-3.12-3.29-5.15-6.46-6.09-9.53-1.76-6.13-1.56-11.03.61-14.68,2.17-3.65,5.52-6.39,10.06-8.22,4.54-1.83,9.75-2.92,15.64-3.29,5.89-.36,11.68-.33,17.37.11s10.83,1.13,15.44,2.08c4.6.95,7.85,1.79,9.75,2.52v39.87c-13.54-6.72-24.92-11.9-34.12-15.55Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.36,2529.97c5.14,0,9.38,1.42,12.7,4.27,3.32,2.85,5.92,6.61,7.82,11.28,1.89,4.68,3.15,10.08,3.76,16.21.61,6.13.81,12.49.61,19.06s-.71,13.11-1.52,19.61c-.81,6.5-1.66,12.53-2.54,18.07-.88,5.55-1.76,10.37-2.64,14.46-.88,4.09-1.46,7.01-1.73,8.76h-39c6.5-19.13,11.85-36.29,16.05-51.48,1.76-6.43,3.32-12.71,4.67-18.84,1.35-6.13,2.3-11.61,2.84-16.43.54-4.82.57-8.73.1-11.72-.48-2.99-1.73-4.49-3.76-4.49-4.34,0-8.46,2.63-12.39,7.89-3.93,5.26-7.55,11.91-10.87,19.94-3.32,8.03-6.23,16.83-8.73,26.4-2.51,9.57-4.5,18.66-5.99,27.28l-.81,21.47h-20.11v-153.36l26-2.19-4.06,104.94c1.76-6.57,3.86-13.47,6.3-20.7,2.44-7.23,5.28-13.84,8.53-19.83,3.25-5.99,6.94-10.92,11.07-14.79,4.13-3.87,8.7-5.81,13.71-5.81Z",
    style: {
      fill: "#ff29c4",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M887.2,2313.43c19.51,2.47,35.57,6.92,42.48,13.83,6.92,6.92,8.18,20.01-5.54,21.74-13.72,1.73-24.88,1.98-12.39,17.04,12.5,15.07,22.98,25.94-.79,29.39-23.77,3.46-59.83-1.24-71.19,7.66-11.36,8.89,0,40.26-19.51,56.56-19.51,16.3-35.56,14.42-59.23,10.96-22.67-3.31-23.98,20.43-90.55,17.15-23.69-1.17-36.16-18.73-42.73-34.78-6.57-16.06-16.45-18.03-37.44-12.6-21,5.43-24.95-14.57-11.61-23.71,13.34-9.14,22.48-17.29,16.8-24.95-5.68-7.66-11.36-11.12-32.11-13.34-20.75-2.22-25.94-23.22-7.16-35.32,18.77-12.1,69.88-26.2,69.88-26.2l261.1-3.44Z",
    style: {
      fill: "#9b005c",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.39,2071.07c10.76-22.32,25.38-25.49,25.38-25.49",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.65,2435.08c-11.86,0-15.56,11.3-1.48,11.3s22.97-11.3,1.48-11.3Z",
    style: {
      fill: "#9b005c",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.41,2336.76c-7.97,0-7.22,9.63,0,9.63s21.49-9.63,0-9.63Z",
    style: {
      fill: "#9b005c",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.38,2405.81c14.57-.24,26.18,4.94,26.18,9.14s-13.59,9.63-32.6,9.63-14.82-8.89-13.09-11.36c1.73-2.47,4.45-7.16,19.51-7.41Z",
    style: {
      fill: "#9b005c",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.7,2322.81s22.97,16.06-2.96,39.27c-25.94,23.22-61.01-9.63-61.01-9.63l63.97-29.64Z",
    style: {
      fill: "#632d81",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.74,2328.99c-16.2,1.98-33.24,6.42-29.54,27.91,3.71,21.49,41.25,24.51,56.32,13.49,15.07-11.02-26.78-41.4-26.78-41.4Z",
    style: {
      fill: "#632d81",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.11,2070.82s27.56.56,43.31-21.37c15.75-21.93,21.65-38.99,0-70.87-22.92-33.75-39.93-61.31-34.31-99.55,5.62-38.25,81.06-1876.79,81.06-1876.79h-321.06s135.95,1844.73,138.77,1876.23c2.81,31.5,6.75,70.3,1.12,88.3,0,0-20.25,22.5-28.68,66.37-8.44,43.87-46.49,68.74-56.73,70.37-26.43,4.22-45.89,10.54-53.57,22.36-7.26,11.18-5.24,21.37-1.86,26.43-12.79,5.06-31.82,11.88-26.19,34.94-16.87,6.19-50.34,23.34-27,51.74-21.72,14.13-42.6,48.93-7.73,75.93-9.58,22.56-25.38,105.05,60.77,128.28,39.2,10.57,75.88-9.6,97.66-30.05,21.78-20.46,30.12-36.71,43.9-49.29,5.9-5.39,27.99-22.3,39.43-31,4.17-3.17,8.55-6.04,13.03-8.78,76.13-46.56,50.37-133.42,46.67-143.3-3.8-10.12-32.4-74.64-14.76-109.67l6.19-.28Z",
    style: {
      fill: "#f8c1b1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.17,2070.65c10.4-21.59,24.55-24.65,24.55-24.65",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 902.88,
    cy: 1843.72,
    rx: 1.72,
    ry: 3.43,
    transform: "translate(-493.58 338.93) rotate(-16.77)",
    style: {
      fill: "#020000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 908.87,
    cy: 1841.92,
    rx: 1.72,
    ry: 3.43,
    transform: "translate(-492.8 340.58) rotate(-16.77)",
    style: {
      fill: "#020000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.9,1858.45c-3.31.3-5.55-1.25-6.92-2.76-1.7-1.87-2.36-4.04-2.39-4.14-.23-.75.2-1.55.95-1.78.75-.23,1.55.2,1.78.95,0,.03.54,1.72,1.83,3.11,1.6,1.73,3.59,2.21,6.07,1.46,6.03-1.82,5.25-7.64,5.21-7.88-.11-.78.42-1.5,1.2-1.62.76-.12,1.5.41,1.62,1.19.46,2.93-.46,9.01-7.21,11.05-.76.23-1.47.37-2.14.43Z",
    style: {
      fill: "#020000",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M658.75,2277.84c13.12-9.23,22.76-8.27,37.11-.96,5.81,2.96,11.2,6.09,19.69,11.19,15.38,9.24,15.65,32.01,4.77,46.88-9.43,12.9-1.91,2.41-4.43,5.91-15.7,21.78-47.57,31.47-70.94,21.51-13.86-5.91-24.99-16.33-22.4-27.65,4.4-19.17,8.6-25.88,14.01-34.43,6.6-10.42,12.01-15.3,22.18-22.46Z",
    style: {
      fill: "#ffd3d2",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.24,2201.52s-13.78,13.24-4.23,18.14c1.83.94,4.29,2.56,8.09,2.73,3.69.17,6.68-.42,8.97-2.03,10.35-7.27,3.96-20.65-1.86-21.45-6.9-.95-10.96,2.6-10.96,2.6Z",
    style: {
      fill: "#ffd3d2",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.96,2156.61s10.71,8.29-.26,17.42c-10.97,9.14-16.6,4.57-16.6,4.57,0,0-.29-8.23,5.94-14.45,5.18-5.17,10.92-7.54,10.92-7.54Z",
    style: {
      fill: "#ffd3d2",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.61,2119.8c5.66,5.67,5.08,10.51,4.03,13.94-2.87,9.41-14.53,6.71-14.53,6.71,0,0-.51-5.86,3.99-13.11,4.5-7.24,6.51-7.55,6.51-7.55Z",
    style: {
      fill: "#ffd3d2",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.75,2277.84c13.12-9.23,22.76-8.27,37.11-.96,5.81,2.96,11.2,6.09,19.69,11.19,15.38,9.24,15.65,32.01,4.77,46.88-9.43,12.9-1.91,2.41-4.43,5.91-15.7,21.78-47.57,31.47-70.94,21.51-13.86-5.91-24.99-16.33-22.4-27.65,4.4-19.17,8.6-25.88,14.01-34.43,6.6-10.42,12.01-15.3,22.18-22.46Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.04,1919.33s-7.1,7.39,1.22,24.58c8.31,17.19,15.65,24.63,11.41,39.98-3.94,14.27-12.43,19.06-12.43,19.06",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.23,2314.92s14.62-39.44,67.91-55.68c0,0,66.09-20.25,85.86-51.41",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.96,2238.99c27.84-20.25,75.65-31.6,75.65-31.6,42.18-12.94,59.53-36.49,59.53-36.49",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.35,2141.69c-9.84,18.28-51.88,29.61-51.88,29.61,0,0-27.14,8.07-48.51,15.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.82,2116.69s-4.77,12.16-19.11,20.28c-10.62,6.01-29.87,10.16-29.87,10.16,0,0-12.43,2.4-20.73,4.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.95,2268.6c-1.7,6.02,5.45,19.95,21.48,13.9,21.03-7.93,20.03-25.84,10.83-34.03-8.3-7.38-18.31-1.36-18.31-1.36,0,0-4.36,4.64-8.46,10.35-3.28,4.56-4.52,7.52-5.53,11.13Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.24,2201.87s-13.78,13.24-4.23,18.14c1.83.94,4.29,2.56,8.09,2.73,3.69.17,6.68-.42,8.97-2.03,10.35-7.27,3.96-20.65-1.86-21.45-6.9-.95-10.96,2.6-10.96,2.6Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.96,2156.61s10.71,8.29-.26,17.42c-10.97,9.14-16.6,4.57-16.6,4.57,0,0-.29-8.23,5.94-14.45,5.18-5.17,10.92-7.54,10.92-7.54Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.61,2119.8c5.66,5.67,5.08,10.51,4.03,13.94-2.87,9.41-14.53,6.71-14.53,6.71,0,0-.51-5.86,3.99-13.11,4.5-7.24,6.51-7.55,6.51-7.55Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.89,2386.05c-12.1,0-21.24,5.19-21.24,10.62s8.65,8.65,27.17,5.93c18.53-2.72,21-6.18,21-9.88s-8.89-6.67-26.92-6.67Z",
    style: {
      fill: "#9b005c",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.74,2448.21c-3.88.49-7.74,1.12-11.59,1.75-3.64.59-7.14,1.24-10.56,2.7-.47.2-.94.42-1.32.76-.78.7-.87,1.74-.49,2.68.98,2.43,3.74,3.27,6.07,3.81,2.76.65,5.61.74,8.43.73,4.27-.02,8.54-.27,12.74-1.03,3.19-.57,7.06-1.43,9.61-3.57,1.52-1.27,2.59-3.48,1.62-5.39-.9-1.76-2.95-2.37-4.78-2.62-3.23-.44-6.47-.24-9.71.16Z",
    style: {
      fill: "#9b005c",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.28,2438.66s13.59,37.3,53.6,25.19c40.01-12.1,25.44-48.66,25.44-48.66l-79.04,23.47Z",
    style: {
      fill: "#632d81",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.55,2293.51c-13.54,0-15.37,1.5-20.22,13.02-4.86,11.5-13.82,23.01-28.4,23.01s-27.12-9.26-41.95,12.01c-14.84,21.26-10.23,18.76-36.06,21.01-25.83,2.25-19.19,30.02-31.71,48.78-12.54,18.77-27.37,6.76-29.41-1.5-2.05-8.26-4.86-20.52-13.82-20.52s-10.49,11.01-14.58,22.26c-4.09,11.26-12.27,7.26-15.86,3.76-3.58-3.5-9.72-13.24-13.81-13.24s-7.84,5.38-11.96,5.38c-2.65,0-5.86-2.21-7.82-3.8,5.84,12.77,17.2,19.82,28.87,27.98,15.43,10.79,40.25,16.01,58.98,13.98,24.48-2.64,48.44-18.49,60.58-29.41,10.32-9.29,11.77-7.21,20.55-17.82,4.17-5.03,18.48-23.34,23.2-28.03,14.23-14.15,25.36-21.78,38.95-33.02,2.28-1.88,5.2-2.91,7.87-4.42,19.99-11.32,37.49-23.92,44.86-38.37.29-.57-5.05-4.07-5.85-1.07-2.52.29-4.64,0-12.39,0Z",
    style: {
      fill: "#9b005c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.87,2401.44s5.5,5.38,9.62,5.38,7.87-5.38,11.97-5.38,10.23,9.73,13.81,13.23c3.58,3.5,11.77,7.5,15.86-3.75,4.09-11.26,5.63-22.26,14.58-22.26s11.77,12.26,13.81,20.51c2.05,8.26,16.88,20.26,29.42,1.5,12.53-18.76,5.88-46.53,31.72-48.78,25.83-2.25,21.23.25,36.07-21.01,14.84-21.26,27.37-12.01,41.95-12.01,14.58,0,23.53-11.51,28.39-23.01,4.86-11.51,6.68-13.01,20.22-13.01s19.45-1,19.45-1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "4.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.4,2381.74c-6.21,0-8.47,5.64-8.47,10.35s3.01,9.59,8.47,9.59,10.16-5.46,10.16-9.97-3.39-9.97-10.16-9.97Z",
    style: {
      fill: "#942469",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.41,2362.37c-.27,2.05,2.26,6.21,5.83,6.21s6.96-2.63,6.96-5.27-2.26-6.4-6.4-6.4-6.02,2.63-6.4,5.46Z",
    style: {
      fill: "#942469",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.18,2341.3c0,3.76,3.57,8.84,8.28,8.84s8.09-4.33,8.09-7.71-4.33-9.41-8.18-9.41-8.18,2.63-8.18,8.28Z",
    style: {
      fill: "#942469",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.11,2070.82s27.56.56,43.31-21.37c15.75-21.93,21.65-38.99,0-70.87-22.92-33.75-39.93-61.31-34.31-99.55,5.62-38.25,81.06-1876.79,81.06-1876.79h-321.06s135.95,1844.73,138.77,1876.23c2.81,31.5,6.75,70.3,1.12,88.3,0,0-20.25,22.5-28.68,66.37-8.44,43.87-46.49,68.74-56.73,70.37-26.43,4.22-45.89,10.54-53.57,22.36-7.26,11.18-5.24,21.37-1.86,26.43-12.79,5.06-31.82,11.88-26.19,34.94-16.87,6.19-50.34,23.34-27,51.74-21.72,14.13-42.6,48.93-7.73,75.93-9.58,22.56-25.38,105.05,60.77,128.28,39.2,10.57,75.88-9.6,97.66-30.05,21.78-20.46,30.12-36.71,43.9-49.29,5.9-5.39,27.99-22.3,39.43-31,4.17-3.17,8.55-6.04,13.03-8.78,76.13-46.56,50.37-133.42,46.67-143.3-3.8-10.12-32.4-74.64-14.76-109.67l6.19-.28Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.75,2277.84c13.12-9.23,22.76-8.27,37.11-.96,5.81,2.96,11.2,6.09,19.69,11.19,15.38,9.24,15.65,32.01,4.77,46.88-9.43,12.9-1.91,2.41-4.43,5.91-15.7,21.78-47.57,31.47-70.94,21.51-13.86-5.91-24.99-16.33-22.4-27.65,4.4-19.17,8.6-25.88,14.01-34.43,6.6-10.42,12.01-15.3,22.18-22.46Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.95,2268.6c-1.7,6.02,5.45,19.95,21.48,13.9,21.03-7.93,20.03-25.84,10.83-34.03-8.3-7.38-18.31-1.36-18.31-1.36,0,0-4.36,4.64-8.46,10.35-3.28,4.56-4.52,7.52-5.53,11.13Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.22,2268.99c-1.7,6.02,5.18,19.56,21.21,13.51,21.03-7.93,20.03-25.84,10.83-34.03-5.72-5.09-9.3-4.44-12.81-3.16-1.58.58-5.07,3.22-6.18,4.49-1.63,1.85-4.55,4.17-7.16,7.79-3.28,4.56-4.87,7.78-5.89,11.39Z",
    style: {
      fill: "#ffd3d2",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.27,2168.66s-1.28,2.67,1.18,5.2c2.37,2.43,3.47,2.07,3.47,2.07-.82.41-2.19.9-3.55,1.26-1.76.36-2.1.4-3.97.04,0,0,.18-2.61.96-4.57.69-1.88,1.22-3.01,1.91-4Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.17,2138.15s-.86.09-2.52-1.74c-1.48-1.63-.93-2.99-.93-2.99-.26.79-.53,1.58-.74,2.6-.21.9-.36,1.7-.47,2.48.33.03.75.05,1.24.05.28,0,.58,0,.92-.03,1.08-.06,2.11-.27,2.5-.38Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.04,2319.82s.6,17.06,23.65,28.75c21.36,10.83,46.59,5.08,46.59,5.08-16.15,11.47-38.86,12.64-52.88,7.11-17.15-6.77-24.92-16.96-21.68-28.11,3.02-10.4,2.01-7.07,4.32-12.83Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.93,2281.23c-17.68-4.76-15.22-18.55-15.22-18.55-1.13,2.26-1.3,2.83-1.73,3.81-.47,1.07-1.22,2.74-1.24,3.35-.13,4.49.97,6.24,3.22,8.72,3.37,3.72,8.99,4.76,14.97,2.67Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.65,2218.17s-8.95.22-12.48-2.44c-4.03-3.04-2.88-6.8-2.88-6.8-.48.84-3.79,5.41-1.78,7.97.32.37,1.09.92,2.69,1.73,1.33.68,2.12,1.12,3.17,1.44,1.09.33,2.45.5,4.78.45,3.25-.08,5.19-1.13,6.51-2.34Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.76,1953.49s-5.86,1.92-15.58,15.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.48px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndulgeRight);
export default __webpack_public_path__ + "static/media/indulge-right.39cbed4492ed5d442b43a2c3729ece6f.svg";
export { ForwardRef as ReactComponent };